// extracted by mini-css-extract-plugin
export default {"applicantInfo":"ApplicantInfo_applicantInfo__a0oMV","spin":"ApplicantInfo_spin__rK4ov"};